import { Inject, Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject } from 'rxjs';
import { Language } from '../types/language.type';
import { StepFormService } from '@shared/modules/step-form/services/step-form.service';
import { ENV, EnvironmentInterface } from '@core/interface/environment.interface';

@Injectable()
export class LocaleService {

    private _languages: Language[];
    private _defaultLanguage: Language;
    public translationsReady = new BehaviorSubject<boolean>(false);

    constructor(
        @Inject(ENV) environment: EnvironmentInterface,
        private translateService: TranslateService,
        private stepFormService: StepFormService,
        private title: Title,
    ) {

        this._languages = environment.langInstanceConfig.languages;
        this._defaultLanguage = this._languages[0];
        if(this.stepFormService.isDeployedIntoAnotherPage && document.documentElement.lang){
            const deployedPageLang = this._languages.find( lang => {
                return lang.code.toLowerCase() == document.documentElement.lang
            })

            if(deployedPageLang){
                this._defaultLanguage = deployedPageLang;
            }
        }

        translateService.addLangs(this._languages.map(x => {
            return x.code.toLowerCase()
        }));

        translateService.setDefaultLang(this._defaultLanguage.code.toLocaleLowerCase());
        translateService.currentLang = this._defaultLanguage.code.toLocaleLowerCase()
        translateService.get('common.title.' + stepFormService.product).subscribe((res: string) => { this.title.setTitle(res); });

        translateService.getTranslation(translateService.currentLang)
            .subscribe( translations => {
                this.translationsReady.next(true)
            });
    }

    get defaultLanguage(): Language {
        return this._defaultLanguage;
    }

    get languages(): Language[] {
        return this._languages;
    }

    public changeLanguage(language: Language){
        this.translateService.use(language.code.toLowerCase())
        this.translateService.get('common.title.'+this.stepFormService.product).subscribe((res: string) => { this.title.setTitle(res); });
    }
}
